import { Component } from '@angular/core';

@Component({
  selector: 'app-required-field',
  templateUrl: './required-field.component.html',
  styleUrl: './required-field.component.scss'
})
export class RequiredFieldComponent {

}
